import React from 'react';
import LoginMenuPMD from '../LoginMenuPMD';
var customLoginMenus = {
  LoginMenuPMD: LoginMenuPMD
};
var renderCustomLoginMenu = function renderCustomLoginMenu(loginMenu, props) {
  var CustomLoginMenu = loginMenu && customLoginMenus[loginMenu];
  return CustomLoginMenu ? React.createElement(CustomLoginMenu, props) : null;
};
export default renderCustomLoginMenu;